import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const ManageAreas = () => {
  const [areas, setAreas] = useState([]);
  const [newAreaName, setNewAreaName] = useState('');
  const [editingArea, setEditingArea] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchAreas();
  }, []);

  const fetchAreas = async () => {
    try {
      const response = await api.get('/stock-areas');
      setAreas(response.data.areas);
    } catch (err) {
      setError('Failed to load stock areas');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateArea = async (e) => {
    e.preventDefault();
    if (!newAreaName.trim()) return;

    try {
      await api.post('/stock-areas', { 
        name: newAreaName,
        displayOrder: areas.length
      });
      setNewAreaName('');
      fetchAreas();
    } catch (err) {
      alert('Failed to create stock area');
    }
  };

  const handleUpdateArea = async (id, name) => {
    try {
      await api.put(`/stock-areas/${id}`, { name });
      setEditingArea(null);
      fetchAreas();
    } catch (err) {
      alert('Failed to update stock area');
    }
  };

  const handleDeleteArea = async (id) => {
    if (!window.confirm('Are you sure? This will remove all items from this area.')) {
      return;
    }

    try {
      await api.delete(`/stock-areas/${id}`);
      fetchAreas();
    } catch (err) {
      alert('Failed to delete stock area');
    }
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Manage Stock Areas</h2>
          <button className="btn btn-secondary btn-small" onClick={() => navigate('/')}>
            Back to Dashboard
          </button>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleCreateArea} className="mb-3">
          <div className="form-group">
            <label className="form-label">Create New Stock Area</label>
            <div className="flex gap-2">
              <input
                type="text"
                className="form-input"
                placeholder="e.g., Front Freezer, Dry Storage"
                value={newAreaName}
                onChange={(e) => setNewAreaName(e.target.value)}
              />
              <button type="submit" className="btn btn-primary" style={{ whiteSpace: 'nowrap' }}>
                Add Area
              </button>
            </div>
          </div>
        </form>

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <h3 className="mb-2">Your Stock Areas</h3>
            {areas.length === 0 ? (
              <div className="text-center" style={{ padding: '2rem', color: 'var(--text-light)' }}>
                No stock areas yet. Create one above to get started!
              </div>
            ) : (
              <div>
                {areas.map((area) => (
                  <div key={area.id} className="list-item">
                    {editingArea === area.id ? (
                      <div className="flex-between" style={{ width: '100%' }}>
                        <input
                          type="text"
                          className="form-input"
                          defaultValue={area.name}
                          onBlur={(e) => handleUpdateArea(area.id, e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleUpdateArea(area.id, e.target.value);
                            }
                          }}
                          autoFocus
                        />
                        <button 
                          className="btn btn-secondary btn-small"
                          onClick={() => setEditingArea(null)}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <>
                        <div className="list-item-content">
                          <div className="list-item-title">{area.name}</div>
                        </div>
                        <div className="list-item-actions">
                          <button
                            className="btn btn-secondary btn-small"
                            onClick={() => setEditingArea(area.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-small"
                            onClick={() => handleDeleteArea(area.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ManageAreas;
